import {TFunction} from 'react-i18next';

import {CustomerCompanyNameOrTIN} from './selectOptionsComponents/CustomerCompanyNameOrTIN';

const GEN_INFO = 'pages.documents.invoices.create.generalInformation';

type IsFieldRequired = (name: string) => boolean;

/** issueDate ≤ today; dueDate ≥ today (bounds set in the page). */
export type GeneralInfoDateConstraints = {
    issueDateMax?: Date;
    dueDateMin?: Date;
};

const getRequiredFlag = (isFieldRequired?: IsFieldRequired) => (name: string, fallback = false) =>
    isFieldRequired ? isFieldRequired(name) : fallback;

export const formData = (
    t: TFunction<'translation'>,
    allowToEdit: boolean,
    fetchSelectsByName?: Record<string, (payload: any) => Promise<Record<string, string>[]>>,
    isFieldRequired?: IsFieldRequired,
    dateConstraints?: GeneralInfoDateConstraints,
) => ({
    general: [
        {
            type: 'input',
            label: t(`${GEN_INFO}.inputs.irn`),
            name: 'irn',
            disabled: true,
        },
        {
            type: 'date',
            label: t(`${GEN_INFO}.inputs.issueDate`),
            placeholder: t(`${GEN_INFO}.placeholders.selectDate`),
            name: 'issueDate',
            disabled: !allowToEdit,
            required: getRequiredFlag(isFieldRequired)('issueDate'),
            maxDate: dateConstraints?.issueDateMax,
        },
        {
            type: 'date',
            label: t(`${GEN_INFO}.inputs.dueDate`),
            placeholder: t(`${GEN_INFO}.placeholders.selectDate`),
            name: 'dueDate',
            disabled: !allowToEdit,
            required: getRequiredFlag(isFieldRequired)('dueDate'),
            minDate: dateConstraints?.dueDateMin,
        },
        // {
        //     type: 'input',
        //     label: t(`${GEN_INFO}.inputs.issueTime`),
        //     placeholder: t(`${GEN_INFO}.placeholders.timeExample`),
        //     name: 'issueTime',
        //     required: false,
        //     disabled: !allowToEdit,
        //     rules: {
        //         pattern: /^([01]\d|2[0-3]):[0-5]\d:[0-5]\d$/,
        //     },
        // },
    ],
    supplier: [
        [
            {disabled: true, name: 'companyNameAndTIN', placeholder: ''},
            {disabled: true, name: 'companyTIN', placeholder: ''},
        ],
        // {disabled: true, name: 'supplierBusinessDescription', placeholder: ''},
        {disabled: true, name: 'supplierEmail', placeholder: ''},
        {disabled: true, name: 'supplierPhoneNumber', placeholder: ''},
        {disabled: true, name: 'supplierStreetName', placeholder: ''},
    ],
    supplierBankDetails: [
        {
            type: 'input',
            label: t(`${GEN_INFO}.inputs.iban`),
            placeholder: t(`${GEN_INFO}.placeholders.iban`),
            name: 'iban',
            disabled: !allowToEdit,
            required: getRequiredFlag(isFieldRequired)('iban'),
        },
        {
            type: 'input',
            label: t(`${GEN_INFO}.inputs.bic`),
            placeholder: t(`${GEN_INFO}.placeholders.bic`),
            name: 'bic',
            disabled: !allowToEdit,
            required: getRequiredFlag(isFieldRequired)('bic'),
        },
    ],
    customerAuto: [
        {
            type: 'select',
            fetchOptions: fetchSelectsByName?.['customerCompanyNameOrTIN'],
            defaultVal: null,
            label: t(`${GEN_INFO}.inputs.companyNameAndTIN`),
            placeholder: t(`${GEN_INFO}.placeholders.selectFromList`),
            name: 'customerCompanyNameOrTIN',
            disabled: !allowToEdit,
            optionComponent: CustomerCompanyNameOrTIN,
            required: getRequiredFlag(isFieldRequired)('customerCompanyNameOrTIN'),
        },
        {
            type: 'input',
            placeholder: t(`${GEN_INFO}.inputs.supplierEmail`),
            label: t(`${GEN_INFO}.inputs.supplierEmail`),
            disabled: !allowToEdit,
            name: 'customerEmail',
            required: getRequiredFlag(isFieldRequired)('customerEmail'),
        },
        {
            type: 'input',
            placeholder: t(`${GEN_INFO}.inputs.supplierPhoneNumber`),
            label: t(`${GEN_INFO}.inputs.supplierPhoneNumber`),
            disabled: !allowToEdit,
            name: 'customerPhoneNumber',
        },
        {
            type: 'input',
            placeholder: t(`${GEN_INFO}.placeholders.defineAuto`),
            label: t(`${GEN_INFO}.inputs.supplierStreetName`),
            disabled: true,
            name: 'customerAddress',
        },
    ],
});
